import { api } from '@/helpers/core'

export default {
	getData (merchantId) {
		return api.get('/dashboard/' + encodeURI(merchantId))
	}
}
